import React, { useState } from 'react';
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';

import { Popper, Fade, Card, Tooltip, PopperPlacementType } from '@material-ui/core';

import { px, fade } from '../../util/style';
import { colors } from '../../styles/variables';
import without from '../../util/without';

//
// RichTooltop
//
interface InlineDivProps {
  flex?: boolean;
}
const InlineDiv = styled.div<InlineDivProps>`
  display: inline-block;

  ${props =>
    props.flex &&
    `
    display: flex;
    align-items: center;
  `}
`;

interface StyledPopperProps {
  top?: string;
}
const StyledPopper = styled(without('top')(Popper))<StyledPopperProps>`
  z-index: 99999;

  ${props =>
    props.top &&
    `
    top: ${props.top};
  `}
`;

interface TooltipCardProps {
  actionsBar?: boolean;
}
export const TooltipCard = styled(without('actionsBar')(Card))<TooltipCardProps>`
  margin-left: ${px(8)};
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  padding: ${px(14)} ${px(20)};
  background-color: ${fade(colors.deliMustard, 0.85)};

  & svg {
    height: ${px(24)};
    color: ${colors.deliMustard};
    margin-right: ${px(8)};
  }
`;

export const TooltipRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 0;
  margin: ${px(4)} 0;
`;

interface RichTooltipProps {
  disabled?: boolean;
  tooltipContent: React.ReactElement<any, any> | undefined;
  flex?: boolean;
  children: React.ReactNode;
  top?: string;
  placement?: PopperPlacementType;
}
export const RichTooltip = (props: RichTooltipProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [open, setOpen] = useState(false);

  const handleHover: React.MouseEventHandler<HTMLDivElement> = event => {
    if (props.disabled !== true) {
      const { currentTarget } = event;
      setAnchorEl(currentTarget);
      setOpen(o => !o);
    }
  };

  const handleHoverLeave = () => {
    setOpen(false);
  };

  const id = open ? 'tooltip-popper' : undefined;

  return (
    <InlineDiv flex={props.flex} onMouseEnter={e => handleHover(e)} onMouseLeave={() => handleHoverLeave()}>
      {props.children}
      <StyledPopper id={id} open={open} anchorEl={anchorEl} placement={props.placement} top={props.top} transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={250}>
            {props.tooltipContent}
          </Fade>
        )}
      </StyledPopper>
    </InlineDiv>
  );
};

// LightTooltip
export const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#fff',
    color: '#212121',
    boxShadow: theme.shadows[1],
    border: '1px solid #DFDEDC',
    fontSize: 13,
    borderRadius: 4,
    padding: 8
  }
}))(Tooltip);
